module.exports = __webpack_public_path__ + "img/Sec02L1.595d1dc7.jpg";